
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["picBroken_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M341.333 917.333A21.333 21.333 0 01320 938.667H96a53.393 53.393 0 01-53.333-53.334v-44.5l227.126-227.12a10.667 10.667 0 0115.08 0L404.667 733.5 242.167 896H320a21.333 21.333 0 0121.333 21.333zm0-597.333a64 64 0 10-64 64 64.073 64.073 0 0064-64zM239.62 583.54L42.667 780.5V138.667A53.393 53.393 0 0196 85.333h480a21.333 21.333 0 0119.08 30.874l-165.427 330.86 89.474 149.126a21.333 21.333 0 01-3.207 26.06l-81.087 81.08L315.047 583.54a53.4 53.4 0 00-75.427 0zm37.713-156.873C336.147 426.667 384 378.813 384 320s-47.853-106.667-106.667-106.667S170.667 261.187 170.667 320s47.853 106.667 106.666 106.667zM928 128H661.333a21.333 21.333 0 00-19.08 11.793L535.587 353.127a21.333 21.333 0 001.173 21.133L652.6 553.227l55.687-55.687a53.4 53.4 0 0175.426 0l197.62 197.627V181.333A53.393 53.393 0 00928 128zM746 524.587a10.6 10.6 0 00-7.54 3.126L581.933 684.24l10.667 17.74-203.653 244.36a21.333 21.333 0 0016.386 34.993H928A53.393 53.393 0 00981.333 928V755.5L753.54 527.713a10.6 10.6 0 00-7.54-3.126z","fill":"#dbdbdb"}})])
          )
        }
      }
    